import { NewHomePageHeader } from "./NewHomepageHeader";
import { styled } from '@mui/material/styles';
import { AuthHeader } from "./AuthHeader";
import { useOktaAuth } from '@okta/okta-react';
import { useSelector } from "react-redux";
import { headerData } from "../../data/headerData";

const NonPrintableWrapper = styled('div')`
  @media print {
    display: none;
  }
`;

const Header = ({ authenticated = false, setProcessing }) => {
  const { authState } = useOktaAuth() || '';

  return (
    <>
      <NonPrintableWrapper>
      {
        (localStorage.getItem("currentUser") && localStorage.getItem("currentUser") !== "undefined" && authState?.isAuthenticated) || authenticated ? (
          <AuthHeader
            headerData={headerData}
          />
        ) :
        <NewHomePageHeader headerData={headerData} setProcessing={setProcessing}/>
      }
    </NonPrintableWrapper>
    </>
  );
};

export default Header;